/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ events: NonNullable<unknown>, groups: NonNullable<unknown> }} Assistant_Restore_SummaryInputs */



/**
* | output |
* | --- |
* | "{events} events will change in: {groups}." |
*
* @param {Assistant_Restore_SummaryInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restore_summary = /** @type {((inputs: Assistant_Restore_SummaryInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Restore_SummaryInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Les événements ${i?.events} changeront dans : ${i?.groups}.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Ereignisse der ${i?.events} ändern sich in: ${i?.groups}.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Gli eventi ${i?.events} cambieranno in: ${i?.groups}.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`События ${i?.events} изменятся в: ${i?.groups}.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Los eventos ${i?.events} cambiarán en: ${i?.groups}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.events} 事件将在 ${i?.groups} 中发生变化。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.events} イベントは ${i?.groups} で変更されます。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.events} घटनाएँ ${i?.groups} में बदलेंगी।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Os eventos ${i?.events} serão alterados em: ${i?.groups}.`)
	return /** @type {LocalizedString} */ (`${i?.events} events will change in: ${i?.groups}.`)
});